import { render, staticRenderFns } from "./distributionModeModal.vue?vue&type=template&id=b7e73b50&scoped=true"
import script from "./distributionModeModal.vue?vue&type=script&lang=js"
export * from "./distributionModeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e73b50",
  null
  
)

export default component.exports